import { render } from "./ConfirmationView.vue?vue&type=template&id=2037ca44&scoped=true"
import script from "./ConfirmationView.vue?vue&type=script&lang=js"
export * from "./ConfirmationView.vue?vue&type=script&lang=js"

import "./ConfirmationView.vue?vue&type=style&index=0&id=2037ca44&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2037ca44"]])

export default __exports__